import { Theme } from "@mui/material"

export const formStyles = {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  mt: { xs: 4, md: 2.25 },
  mb: { xs: 5, md: 12.5 },
  maxWidth: 970,
  mr: 'auto',
  ml: 'auto'
}

export const clearBtnStyles = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  right: '48px',
  borderRadius: '8px',
}

export const getSubmitBtnStyles = (theme: Theme) => ({
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  right: 0,
  color: 'white',
  borderRadius: '8px',
  backgroundColor: `${theme.palette.primary.main}`,
  border: `1px solid ${theme.palette.primary.main}`,
  "&:hover": {
    backgroundColor: `${theme.palette.action.hover}`,
    border: `1px solid ${theme.palette.action.hover}`,
  },
  "&:focus": {
    backgroundColor: `${theme.palette.action.hover}`,
    border: `1px solid ${theme.palette.action.hover}`,
  },
})

export const getInputFieldStyles = (theme: Theme) => ({
  flex: 1,
  '& input': {
    paddingLeft: 1,
    paddingRight: 8,
    fontSize: { xs: '1rem', md: '1.125rem' },
    fontWeight: 500,
    borderColor: 'transparent'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
      borderBottom: '1px solid',
      borderColor: `${theme.palette.grey[600]}`,
      borderRadius: 0
    }
  },
})